'use client';

import Bubble from './Bubble';
import styles from './AgentTypingIndicator.module.scss';

export interface AgentTypingIndicatorProps {
  /** The visible typing status, for example "Sarah is typing". */
  text: string;
}

/**
 * Displays the animated indicator shown while a care team member is typing.
 * The consumer controls visibility, placement, and live-region announcements.
 */
export default function AgentTypingIndicator({ text }: AgentTypingIndicatorProps) {
  return (
    <div className={styles.container}>
      <span className={styles.label}>{text}</span>
      <Bubble responder="agent" variant="typing">
        <span className={styles.dotContainer}>
          <span className={styles.dot} />
          <span className={styles.dot} />
          <span className={styles.dot} />
        </span>
      </Bubble>
    </div>
  );
}
